import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import { t } from '../../../../services/i18nService';

import PaperBasedGap from '../paperBasedInteraction/PaperBasedInteractionInput';
import GapChoicesContainer from './GapChoicesContainer';

import styles from './gapMatchInteraction.scss';
import customFieldsService from '../../../../services/CustomFieldsService';
import customFieldsConstants from '../../../../constants/CustomFieldsConstants';
import LoadTracker from '../../../../services/LoadTracker';

class GapMatchPaperBased extends React.Component {
    static propTypes = {
        reportGapsReady: PropTypes.func.isRequired,
        reportGapChoicesContainerReady: PropTypes.func.isRequired,
        gapChoicesContainerRef: PropTypes.func.isRequired,
        model: PropTypes.object.isRequired, // model taken from responseModels related to this interaction
        userResponse: PropTypes.array.isRequired, // array with simpleChoice identifiers
        services: PropTypes.object,
        isReadOnly: PropTypes.bool,
        questionModel: PropTypes.object,
        notDropped: PropTypes.array,
    };

    componentDidUpdate() {
        this.injectGaps();
    }

    getPaperBasedGap = (gapModel, index, gapsTracker) => {
        const { model, questionModel, services } = this.props;
        const gapNumber = services.scorableItemNumberingService.getInteractionChoiceNumber(
            questionModel.contentRevisionId, model.identifier, gapModel.identifier
        );

        if (customFieldsService.isMatchingHeadings(questionModel)) {
            return (
                <div className={styles.gapAsLetterIndicator}>
                    {services.utilService.toLatinLetter(index + 1)}
                </div>
            );
        }

        if (customFieldsService.isMatchingSentenceEnding(questionModel)) {
            return (
                <div className={styles.gapAsNumberIndicator}>
                    {gapNumber}
                </div>
            );
        }

        const isShortSize = !customFieldsService.isSummaryCompletionObjective(questionModel);

        const reportReady = gapsTracker.addItemToTrack(`Gap ${gapModel.identifier}`);

        return (
            <PaperBasedGap
                key={gapModel.identifier}
                orderNumber={gapNumber}
                isShortSize={isShortSize}
                reportGapReady={reportReady}
                identifier={gapModel.identifier}
            />
        );
    };

    injectGaps = () => {
        const { model, reportGapsReady } = this.props;

        const injectedGapsTracker = new LoadTracker(reportGapsReady, `GapMatchInteraction ${model.identifier} > injectGaps`);
        const gapsTracker = new LoadTracker(reportGapsReady, `GapMatchInteraction ${model.identifier} > Gaps`);

        model.gapModels.forEach((gapModel, index) => {
            ReactDOM.render(
                this.getPaperBasedGap(gapModel, index, gapsTracker),
                document.getElementById(gapModel.placeholderId)
            );
        });

        injectedGapsTracker.setAllItemsAdded();
        gapsTracker.setAllItemsAdded();
    };

    getMatchHeadingsGapList = () => {
        const { model, services, questionModel } = this.props;
        const title = customFieldsService.getCustomFieldValue(questionModel.customFields, customFieldsConstants.ITEM_RUBRIC_BLANK_2);
        const gaps = model.gapModels.map((gapModel, index) => {
            const gapNumber = services.scorableItemNumberingService.getInteractionChoiceNumber(
                questionModel.contentRevisionId, model.identifier, gapModel.identifier
            );
            return (
                <div className={styles.gapRow} key={`matchHeadingsGap-${index + 1}`}>
                    <span className={styles.number}>{gapNumber}</span>
                    <span className={styles.title}>{title || t('interactions.gapMatch.matchHeadingGapTitle')}</span>
                    <span className={styles.literalIndex}>{services.utilService.toLatinLetter(index + 1)}</span>
                </div>
            );
        });

        return (
            <div className={styles.matchHeadingsGaps}>{gaps}</div>
        );
    };

    handleUserResponsePrint = () => {};

    getGapChoicesContainer = () => {
        const { model, questionModel, notDropped } = this.props;

        return (
            <React.Fragment>
                <GapChoicesContainer
                    {...this.props}
                    model={model}
                    notDropped={notDropped}
                    handleUserResponse={this.handleUserResponsePrint}
                    reportReady={this.props.reportGapChoicesContainerReady}
                    ref={(instance) => { this.props.gapChoicesContainerRef(instance); }}
                />
                {
                    customFieldsService.isMatchingHeadings(questionModel)
                        ? this.getMatchHeadingsGapList()
                        : null
                }
            </React.Fragment>
        );
    }

    render() {
        const { questionModel, model } = this.props;
        const optionBoxAboveGaps = (
            customFieldsService.isMatchingHeadings(questionModel)
            || customFieldsService.isFlowChartCompletionObjective(questionModel)
            || customFieldsService.isMatching1(questionModel)
        );
        const canvasClasses = [styles.container, styles.pbContainer];
        if (customFieldsService.isMatching1(questionModel)) {
            canvasClasses.push(styles.isMatching1);
        }
        if (
            customFieldsService.isMatching1(questionModel) ||
            customFieldsService.isMatchingSentenceEnding(questionModel)
        ) {
            canvasClasses.push(styles.allowBr);
        }
        if (
            customFieldsService.isSummaryCompletionObjective(questionModel) ||
            customFieldsService.isSummaryCompletionProductive(questionModel)
        ) {
            canvasClasses.push(styles.isPBSummaryCompletion);
        }

        return (
            <div className="interaction skipMathCache allowed-break-inside">
                <div className={`${styles.wrapper}`}>
                    {
                        optionBoxAboveGaps
                            ? this.getGapChoicesContainer()
                            : null
                    }
                    <div
                        ref={(canvas) => { this.canvas = canvas; }}
                        className={canvasClasses.join(' ')}
                        dangerouslySetInnerHTML={{ __html: model.interactionBody }}
                    />
                    {
                        !optionBoxAboveGaps
                            ? this.getGapChoicesContainer()
                            : null
                    }
                </div>
            </div>
        );
    }
}

export default GapMatchPaperBased;
